import classes from './Subtitle.module.css'

const Subtitle = ({children}) => {
    return <div className={classes.subtitle}>{children}</div>
}

export default Subtitle